import { SET_EPISODE_DATA, SET_NEXT_EPISODE_DATA, SET_RECOMMENDED_PROGRAMME } from '../../constants'

const initialState = {
  currentEpisode: null,
  nextEpisode: null,
  recommendedProgramme: null,
  playerApiPath: null,
}

const EpisodeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_EPISODE_DATA:
      return {
        ...state,
        currentEpisode: action.payload,
        playerApiPath: `/episodes/${action.payload.episodeInfo.episodeId}`,
        recommendedProgramme: null, // Clear recommendedProgramme when new episode loads
      }
    case SET_NEXT_EPISODE_DATA:
      return {
        ...state,
        nextEpisode: action.payload,
      }
    case SET_RECOMMENDED_PROGRAMME:
      return {
        ...state,
        recommendedProgramme: action.payload,
      }
    default:
      return state
  }
}

export default EpisodeReducer
